export enum AiChatDocumentMessagePayloadRoleEnum {
  User = 'user',
  Assistant = 'assistant',
  System = 'system',
}
